// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LegndsColour {
  color: black;
}
.recharts-wrapper {
  width: 100% !important;
  height: 500px !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/PieChart/index.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B","sourcesContent":[".LegndsColour {\r\n  color: black;\r\n}\r\n.recharts-wrapper {\r\n  width: 100% !important;\r\n  height: 500px !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
